import Reveal from "@/components/feature/Reveal";
import CountUp from "@/components/feature/CountUp";
import { experienceStats } from "@/mocks/stats";

export default function Experience() {
  return (
    <section className="relative px-4 md:px-8 lg:px-12 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Architectural%20detail%20of%20modern%20residential%20building%20with%20warm%20wood%20and%20concrete%20textures%2C%20geometric%20facade%2C%20soft%20natural%20light%2C%20elegant%20minimalist%20design%2C%20premium%20architectural%20photography%2C%20warm%20neutral%20earthy%20tones%2C%20cinematic%20composition&width=1800&height=1000&seq=experience-adj&orientation=landscape"
          alt="Detalle arquitectónico de proyectos ADJ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/75" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col gap-12">
        <Reveal className="flex flex-col items-center gap-4 text-center">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-primary-300">
            Nuestra experiencia
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-background-50">
            Autoridad y trayectoria inmobiliaria
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {experienceStats.map((stat, index) => (
            <Reveal key={stat.id} delay={index * 100}>
              <div className="flex flex-col items-center gap-2 text-center">
                <span className="font-heading text-4xl md:text-6xl font-semibold text-background-50">
                  <CountUp value={stat.value} suffix={stat.suffix} />
                </span>
                <span className="text-xs md:text-sm text-background-100/80">{stat.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}